import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseService } from '@services/base-service.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ICardProductOrderList, IProduct } from './card-product-order-list.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { TableColumn } from '@shared/interface/table.interface';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { IUnfinishedProduct } from '@models/spm.model';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: 'app-card-product-order-list',
  templateUrl: './card-product-order-list.component.html',
  styleUrls: ['./card-product-order-list.component.scss'],
})
export class CardProductOrderListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() url!: string;
  @Input() id!: string;
  @Input() title: string = 'List Produk Diproses';
  @Input() isTypeSO = false;

  productOrder: BehaviorSubject<ICardProductOrderList> = new BehaviorSubject<ICardProductOrderList>({} as ICardProductOrderList);

  // table
  tableColumns: TableColumn[];
  displayedColumns: string[];
  tableFooter: string[];

  listProduct: IProduct[];
  productNotFulfilledSubject = new BehaviorSubject<IUnfinishedProduct | null>(null);
  baseDatasource: BaseDatasource<IProduct>;

  private unsubscribe: Subscription[] = [];

  constructor(private baseService: BaseService, private baseTableService: BaseTableService<IProduct>, private utils: UtilitiesService) {}

  ngOnInit(): void {
    this.setTableData();
    this.getProducts();
    this.initData();
  }

  ngAfterViewInit() {}

  getProducts() {
    this.baseDatasource.isFinishLoadingSubject.next(false);
    const endpoint = this.url + this.id;
    const products = this.baseService.getData<ICardProductOrderList>(endpoint).subscribe((resp) => {
      if (resp && resp.success) {
        this.productOrder.next(resp.data);
        this.baseDatasource.isFinishLoadingSubject.next(true);
      }
    });

    this.unsubscribe.push(products);
  }

  setTableData() {
    const data = this.baseTableService.responseDatabase.subscribe((response) => (this.baseDatasource = response));

    this.tableColumns = [
      { key: 'product_name', title: 'PRODUK' },
      { key: 'qty_order', title: 'QTY Order' },
      { key: 'qty_delivery_unit', title: 'BERAT/VOLUME ORDER' },
    ];

    this.tableFooter = ['total_text', 'total_order', 'total_weight'];

    if (this.isTypeSO) {
      const qty_process = { key: 'qty_process', title: 'QTY Diproses' };
      this.tableColumns.push(qty_process);
      this.tableFooter.push('total_process');
    }

    this.displayedColumns = this.tableColumns.map((item) => item.key);
    this.unsubscribe.push(data);
  }

  initData() {
    this.productOrder.subscribe((res) => {
      if (res && !Object.keys(res).length) return;
      this.listProduct = res.products;
      this.mapperProductNotFulfilled().then((res) => this.productNotFulfilledSubject.next(res));
    });
  }

  hasProductNotFulfilled() {
    return !!this.productOrder.value.not_fullfilled_products?.length;
  }

  async mapperProductNotFulfilled() {
    const { not_fullfilled_products } = this.productOrder.value;
    return <IUnfinishedProduct>{
      message: 'Sebagian produk tidak diproses.',
      title: 'Produk tidak diproses dikembalikan ke Purchase Order.',
      not_fulfilled: not_fullfilled_products,
    };
  }

  isNoProduct = () => this.baseDatasource.isFinishLoadingSubject.value && this.listProduct && !this.listProduct.length;

  handleNoImage = (e: Event) => this.utils.setDefaultImageProduct(e);

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
